import axios from "axios";
import { API } from "shared/services";

const CancelToken = axios.CancelToken;
const historyRequest = [];

function cancelOldRequests() {
  while (historyRequest.length > 0) {
    const cancelSource = historyRequest[0];

    cancelSource?.cancel("cancel");

    historyRequest.pop();
  }
}

export async function getCustomer(customer) {
  cancelOldRequests();

  const queryParams = customer?.updated_at
    ? `?updated_at=${customer?.updated_at}`
    : "";

  const source = CancelToken.source();
  historyRequest.push(source);
  const { data } = await API.get(`/customers/${customer.id}${queryParams}`, {
    cancelToken: source.token,
  });

  return data;
}

export function updateReplySources(id, replySources) {
  return API.patch(`customers/${id}`, {
    customer: {
      reply_sources: replySources,
    },
  });
}

export function listCustomers(
  page = 1,
  user_ids = [],
  tab = "",
  tag_ids = [],
  scope = "all"
) {
  let params = `page=${page}&tab=${tab}&scope=${scope}`;

  if (user_ids?.length > 0) {
    const queryUserIds = `&user_ids[]=${user_ids?.join("&user_ids[]=")}`;
    params += `${queryUserIds}`;
  }

  if (tag_ids?.length > 0) {
    const queryTagIds = `&customer_tag_ids[]=${tag_ids?.join(
      "&customer_tag_ids[]="
    )}`;
    params += `${queryTagIds}`;
  }
  return API.get(`customers?${params}`);
}

export async function getTabTotalPages(users, tab, tags) {
  const { headers } = await listCustomers(1, users, tab, tags);
  const totalPages = headers["total-pages"];

  return totalPages;
}

export async function getAllTabsCustomers(users, tags, scope) {
  const [todo, visits, activities, favorites, all] = await Promise.all([
    listCustomers(1, users, "todo", tags, scope),
    listCustomers(1, users, "visits", tags, scope),
    listCustomers(1, users, "activities", tags, scope),
    listCustomers(1, users, "favorites", tags, scope),
    listCustomers(1, users, "all", tags, scope),
  ]);

  const data = [
    ...todo.data,
    ...visits.data,
    ...activities.data,
    ...favorites.data,
    ...all.data,
  ];

  const totals = {
    totalActivities: activities.headers["total-count"],
    totalAll: all.headers["total-count"],
    totalFavorites: favorites.headers["total-count"],
    totalTodo: todo.headers["total-count"],
    totalVisits: visits.headers["total-count"],
  };

  return [data, totals];
}
export function setCustomerTags(id, tags) {
  return API.put(`customers/${id}`, { customer: { customer_tag_ids: tags } });
}

export function multipleCustomersForward(selectedContacts, selectedUser) {
  return API.post(`customers/forward`, {
    ids: selectedContacts,
    customer: {
      user: {
        id: selectedUser,
      },
    },
  });
}
